import axios from "axios"

//const
const REPRE_LICENSE_TYPE_GET = "createEnterpriseDetails/REPRE_LICENSE_TYPE_GET"
const PROFESSION_GET = "createEnterpriseDetails/PROFESSION_GET"
const PROPERTY_GET = "createEnterpriseDetails/PROPERTY_GET"
const SCALE_GET = "createEnterpriseDetails/SCALE_GET"
const REPRE_LICENSE_LOCATION_GET = "createEnterpriseDetails/REPRE_LICENSE_LOCATION_GET"
// const PROVINCE_GET = "createEnterpriseDetails/PROVINCE_GET"
// const CITY_GET = "createEnterpriseDetails/CITY_GET"
// const DISTRICT_GET = "createEnterpriseDetails/DISTRICT_GET"
// const GET_ALL_CITIES = "createEnterpriseDetails/GET_ALL_CITIES"
// const GET_ALL_DISTRICTS = "createEnterpriseDetails/GET_ALL_DISTRICTS"
const REGION_GET = "createEnterpriseDetails/REGION_GET"

//reducer
export const createEnterpriseDetails = (state = {
  regions:[],
  provinces: [],
  cities: [],
  districts: [],
  repreLicenseLocations: [],
  scales: [],
  properties: [],
  professions: [],
  repreLicenseTypes: [],
}, action) => {
  switch (action.type) {
    case REPRE_LICENSE_TYPE_GET:
      console.log("Type: ", action.data._embedded.repreLicenseTypes)
      return {
        ...state,
        repreLicenseTypes: action.data._embedded.repreLicenseTypes

      };

    case PROFESSION_GET:
      console.log("PROFESSION: ", action.data._embedded.professions)
      return {
        ...state,
        professions: action.data._embedded.professions

      };

    case PROPERTY_GET:
      console.log("PROPERTY: ", action.data._embedded.properties)
      return {
        ...state,
        properties: action.data._embedded.properties

      };

    case SCALE_GET:
      console.log("SCALE: ", action.data._embedded.scales)
      return {
        ...state,
        scales: action.data._embedded.scales

      };

    case REPRE_LICENSE_LOCATION_GET:
      console.log("REPRELICENSELOCATION: ", action.data._embedded.repreLicenseLocations)
      return {
        ...state,
        repreLicenseLocations: action.data._embedded.repreLicenseLocations

      };


    case REGION_GET:
      console.log("REGIONS: ", action.data.content);
      return {
        ...state,
        regions:action.data.content.map(region => {
          region.label = region.name;
          region.value = region.code;
          region.children.map(city => {
            city.label = city.name;
            city.value = city.code;
            city.children.map(district => {
              district.label = district.name;
              district.value = district.code;
              return district;
            });
            return city;
          });
          return region;
        })
      }
    // case PROVINCE_GET:
    //   console.log("PROVINCE: ", action.data._embedded.provinces)
    //   return {
    //     ...state,
    //     provinces: action.data._embedded.provinces
    //
    //   };
    //
    // case CITY_GET:
    //   console.log("CITY: ", action.data._embedded.cities)
    //   return {
    //     ...state,
    //     cities: action.data._embedded.cities
    //
    //   };
    //
    // case DISTRICT_GET:
    //   console.log("DISTRICT: ", action.data._embedded.districts)
    //   return {
    //     ...state,
    //     districts: action.data._embedded.districts
    //
    //   };
    //
    // case GET_ALL_CITIES: {
    //   console.log("allcities", action.data)
    //   return {
    //     ...state,
    //     cities: action.data
    //   }
    // }
    //
    // case GET_ALL_DISTRICTS: {
    //   return {
    //     ...state,
    //     districts: action.data
    //   }
    // }
    default:
      return state
  }
}

//action
export const getRepreLicenseType = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseTypes`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("response", response.data);
        dispatch(getRepreLicenseTypeDone(response.data))
      }
    })
}

export const getProfession = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/professions`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("profession", response.data);
        dispatch(getProfessionDone(response.data))
      }
    })
}

export const getProperty = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/properties`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("property", response.data);
        dispatch(getPropertyDone(response.data))
      }
    })
}

export const getPropertyDone = (data) => {
  return {
    type: PROPERTY_GET,
    data: data
  }
};

export const getScale = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/scales`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("scale", response.data);
        dispatch(getScaleDone(response.data))
      }
    })
}

export const getRepreLicenseLocation = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseLocations`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("repreLicenseLocation", response.data);
        dispatch(getRepreLicenseLocationDone(response.data))
      }
    })
}

export const getRegion = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/getProvinces?name=&pageNumber=0&pageSize=200`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("regions", response.data);
        dispatch(getRegionDone(response.data))
      }
    })
}

export const getRegionDone = (data) => {
  return {
    type: REGION_GET,
    data: data
  }
};
// export const getProvince = () => (dispatch) => {
//
//   let myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//
//   return axios({
//     method: "GET",
//     url: `/api-user/provinces`,
//     contentType: "application/json",
//   }).then(
//     response => {
//       if (response.status === 200) {
//         console.log("provinces", response.data);
//         dispatch(getProvinceDone(response.data))
//       }
//     })
// }
//
// export const getCity = () => (dispatch) => {
//
//   let myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//
//   return axios({
//     method: "GET",
//     url: `/api-user/cities`,
//     contentType: "application/json",
//   }).then(
//     response => {
//       if (response.status === 200) {
//         console.log("cities", response.data);
//         dispatch(getCityDone(response.data))
//       }
//     })
// }
//
// export const getDistrict = () => (dispatch) => {
//
//   let myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//
//   return axios({
//     method: "GET",
//     url: `/api-user/districts`,
//     contentType: "application/json",
//   }).then(
//     response => {
//       if (response.status === 200) {
//         console.log("districts", response.data);
//         dispatch(getDistrictDone(response.data))
//       }
//     })
// }
//
// export const getDistrictDone = (data) => {
//   return {
//     type: DISTRICT_GET,
//     data: data
//   }
// };
//
// export const getCityDone = (data) => {
//   return {
//     type: CITY_GET,
//     data: data
//   }
// };
//
// export const getProvinceDone = (data) => {
//   return {
//     type: PROVINCE_GET,
//     data: data
//   }
// };

export const getRepreLicenseLocationDone = (data) => {
  return {
    type: REPRE_LICENSE_LOCATION_GET,
    data: data
  }
};

export const getScaleDone = (data) => {
  return {
    type: SCALE_GET,
    data: data
  }
};

export const getProfessionDone = (data) => {
  return {
    type: PROFESSION_GET,
    data: data
  }
};

export const getRepreLicenseTypeDone = (data) => {
  return {
    type: REPRE_LICENSE_TYPE_GET,
    data: data
  }
};

// export const getAllCities = (province) => (dispatch) => {
//   return axios({
//     method: "GET",
//     url: `/api-user/cities/search/provinceName?provinceName=${province}`
//   }).then(
//     response => {
//       dispatch(getAllCitiesDone(response.data._embedded.cities))
//     }
//   )
// }
//
// export const getAllCitiesDone = (cities) => {
//   return {
//     type: GET_ALL_CITIES,
//     data: cities
//   }
// }
//
// export const getAllDistricts = (city) => (dispatch) => {
//   return axios({
//     method: "GET",
//     url: `/api-user/districts/search/cityName?cityName=${city}`
//   }).then(
//     response => {
//       dispatch(getAllDistrictsDone(response.data._embedded.districts))
//     }
//   )
// }
//
// export const getAllDistrictsDone = (districts) => {
//   return {
//     type: GET_ALL_DISTRICTS,
//     data: districts
//   }
// }
